/**
 * What Stop keeps of an answer that is typing out — exactly what is on the
 * screen at the click, like Claude.ai.
 *
 * The chat reveals streamed text with a typewriter, so at any moment it holds
 * text already RECEIVED (`target`) beyond what is DISPLAYED. Stop used to
 * flush that buffer first: the screen jumped forward by everything received
 * but not yet typed out (staging 2026-10-04: +263…330 characters) and only
 * then froze — the user saw text appear at the very moment they stopped it.
 * Now the buffer is discarded: the display freezes as it is, and the count
 * sent to the server (`shown_chars`) is that displayed text, so the stored
 * answer is the frozen screen.
 *
 * `base` is the text the message had before this stream began (a Continue
 * grows an answer already on screen). It stays on the screen but is not
 * counted: the server adds a Continue's characters to the answer it already
 * has.
 */
export interface TypewriterView {
  base: string;
  displayed: string;
}

export function frozenAtStop(view: TypewriterView): { content: string; shownChars: number } {
  return {
    content: view.base + view.displayed,
    // Code points, as the server counts (Python `len`), not UTF-16 units.
    shownChars: Array.from(view.displayed).length,
  };
}
